require("@fancyapps/fancybox");

$('[data-fancybox]').fancybox({ 
    infobar: false, 
    buttons:  [ "close" ], 
    animationEffect: false,
    btnTpl: {
        // Define custom button HTML
        close: `
            <button data-fancybox-close class="fancybox-close-custom">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                    <g transform="translate(15692 -6572)">
                        <circle cx="16" cy="16" r="16" transform="translate(-15692 6572)" fill="#f5f5f5" opacity="0.1"></circle>
                        <path d="M162.128-1175.678,160.806-1177l-5.242,5.242L150.322-1177,149-1175.678l5.242,5.242L149-1165.194l1.322,1.322,5.242-5.242,5.242,5.242,1.322-1.322-5.242-5.242Z" transform="translate(-15831.87 7758.13)" fill="#ffebd6" fill-rule="evenodd"></path>
                    </g>
                </svg>
            </button>
        `
    }
});